module.exports = __webpack_public_path__ + "static/media/3 gurdian angel tattoo realism saint michael feather wings.1280x1707.6eec7bb8.webp";